import React from "react";
import HomeIcon from "@mui/icons-material/Home";
import EditCalendarIcon from "@mui/icons-material/EditCalendar";
import HealthAndSafetyIcon from "@mui/icons-material/HealthAndSafety";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";

export interface NavItem {
  id: string;
  title: string;
  path: string;
  icon: React.ReactElement;
}

export const providerNavItems: NavItem[] = [
  {
    id: "home",
    title: "Home",
    path: "/providerappointments",
    icon: <HomeIcon />,
  },
  {
    id: "schedule",
    title: "Schedule",
    path: "/availability",
    icon: <EditCalendarIcon />,
  },
];

export const patientNavItems: NavItem[] = [
  {
    id: "home",
    title: "Home",
    path: "/appointments",
    icon: <HomeIcon />,
  },
  {
    id: "benefits-summary",
    title: "Benefits Summary",
    path: "/benefits-summary",
    icon: <HealthAndSafetyIcon />,
  },
  {
    id: "documents",
    title: "Documents",
    path: "/documents",
    icon: <InsertDriveFileIcon />,
  },
];
